<template>
  <v-dialog :value="showErrorMessages" persistent max-width="400">
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>Error!</v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items>
          <v-btn icon color="secondary" @click="closeError()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text justify="center">
        <v-alert
          v-for="(error, index) in errorMessages"
          :key="index"
          text
          dense
          type="error">
          {{ error }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorModal',

  methods: {
    closeError: function () {
      this.$store.commit('clearErrorMessages')
    }
  },

  computed: {
    errorMessages: function () {
      return this.$store.state.errorMessages
    },
    showErrorMessages: function () {
      return this.$store.state.errorMessages.length > 0
    }
  }
}
</script>

<style scoped>

</style>
